export const colors: Record<string, string> = {
  completed: 'var(--primary)',
  disabled: 'var(--darkgrey)',
  default: 'var(--grey)',
}
